import React from "react";
import { IntlShape } from "react-intl";
import { ColumnDefinition, RowDefinition } from "griddle-react";

import { messages as musicMessages } from "@music/messages";
import { Table } from "@ui/Table";
import { CellMonth, CellDateTime, CellBasicNumber, CellMoney, CellBadge } from "@ui/Table/Cells";
import { CellDownloadFiles } from "../CellDownloadFiles";
import { Report as Model } from "../../models";
import { messages } from "../../messages";

interface ReportTableProps {
    reports: Model[];
    intl: IntlShape;
}

// Type the table component
type TypedTable = new () => Table<Model>;
const TypedTable = Table as TypedTable;

const ReportTable = ({ reports, intl: { formatMessage } }: ReportTableProps) => (
    <TypedTable
        data={reports}
        pageSize={reports.length}
        layout="basic"
    >
        <RowDefinition>
            <ColumnDefinition
                id="endDate"
                title={formatMessage(messages.month)}
                customComponent={CellMonth}
                sortable={false}
            />
            <ColumnDefinition
                id="updatedAt"
                title={formatMessage(messages.lastUpdated)}
                customComponent={CellDateTime}
                sortable={false}
            />
            <ColumnDefinition
                id="rowsProcessed"
                title={formatMessage(messages.numberRows)}
                customComponent={CellBasicNumber}
                sortable={false}
            />
            <ColumnDefinition
                id="totalAmount"
                title={formatMessage(messages.amountPayable)}
                customComponent={CellMoney}
                sortable={false}
            />
            <ColumnDefinition
                id="label.name"
                title={formatMessage(musicMessages.labelEntitySingular)}
                sortable={false}
                customComponent={CellBadge}
            />
            <ColumnDefinition
                id="files"
                sortable={false}
                title={formatMessage(messages.download)}
                customComponent={CellDownloadFiles}
            />
            <ColumnDefinition id="label" visible={false} />
        </RowDefinition>
    </TypedTable>
);

export { ReportTable, ReportTableProps };
